import { NavLink } from 'react-router';

import './PageNotFoundAuthed.css';

type Props = {
  label: string;
  info: string;
  to: string;
};

const PageNotFoundCard = ({ label, info, to }: Props) => {
  return (
    <NavLink to={to} className="page-not-found-card">
      <div className="page-not-found-card-content-label">{label}</div>
      <div className="page-not-found-card-content-info">{info}</div>
    </NavLink>
  );
};

export default PageNotFoundCard;
